import { 
    SET_DATA
} from '../actions';


// Inital zoom and center
const initialState = {
};

export default function(state = initialState, action:any){
    switch(action.type){
        case SET_DATA:
            return{
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}